<template>
  <div class="ActorOptions">
    <lm-dropdown
      class="ActorOptions-menu"
      :items="options"
      auto-close
      @select="onSelect"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import LmDropdown from '@/components/ui/LmDropdown'

export default {
  name: 'ActorOptions',
  components: {
    LmDropdown
  },
  data() {
    return {
      options: [
        {label: 'Edit actor', action: 'edit'},
        {label: 'Move actor', action: 'move'},
        {label: 'Merge actor', action: 'merge'},
        {label: 'Squash actor', action: 'squash'},
        {label: 'Delete actor', action: 'delete'}
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape']),
    newActorColor() {
      return (
        this.selectedActor.color ||
        `color${this.currentLandscape.actors.length}`
      )
    }
  },
  methods: {
    onSelect(item) {
      switch (item.action) {
        case 'edit':
          this.openModal(Modal.EDIT_ACTOR)
          break
        case 'move':
          this.openModal(Modal.MOVE_ACTOR)
          break
        case 'merge':
          this.openModal(Modal.MERGE_ACTOR)
          break
        case 'squash':
          this.openModal(Modal.SQUASH_ACTOR)
          break
        case 'delete':
          this.deleteActor()
          break
      }
    },
    openModal(modal) {
      this.$router.push({query: {modal}})
    },
    getDeletePrompt(name, color, descendants, topics, feeds) {
      let prompt = `Are you sure you want to delete the actor
          <span class="${color}">${name}</span>?`

      if (descendants || topics || feeds) {
        prompt += `<br>
              By deleting this you will also permanently delete:
              <ul>`
        if (descendants) {
          prompt +=
            '<li>' +
            this.$options.filters.pluralize(descendants, 'actor') +
            '</li>'
        }
        if (topics) {
          prompt +=
            '<li>' + this.$options.filters.pluralize(topics, 'topic') + '</li>'
        }
        if (feeds) {
          prompt +=
            '<li>' +
            this.$options.filters.pluralize(feeds, 'feed subscription') +
            '</li>'
        }

        prompt += '</ul>'
      }
      return prompt
    },
    deleteActor() {
      let params = {
        entity: 'actor',
        prompt: this.getDeletePrompt(
          this.selectedActor.name,
          'text-' + this.selectedActor.color,
          this.selectedActor.stats.descendants,
          this.selectedActor.stats.totalTopics,
          this.selectedActor.stats.feeds
        )
      }
      EventHub.emit(Events.OPEN_CONFIRM, params, this.doDelete, true)
    },
    doDelete() {
      this.$store.dispatch('deleteActor').then(parentPathArr => {
        this.$router.push({
          name: 'info',
          params: {actor: parentPathArr}
        })
      })
    }
  }
}
</script>
